import { baseUrl, fetchKmsData } from "@kaltura/mediaspace-shared-utils";
import { Suspense, useMemo } from "react";
import { FormProps } from "./types";
import CreateRoomForm, { CreateRoomFormProps } from "./CreateRoomForm";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import FormSkeleton from "./skeleton/FormSkeleton";

type CreateRoomFormContainerProps = Pick<CreateRoomFormProps, "onSubmit">;

export function CreateRoomFormContainer({ onSubmit }: CreateRoomFormContainerProps) {
    // fetch data from kms
    const fetchFormData = useMemo(() => {
        return fetchKmsData<FormProps>(`${baseUrl}/meetingentry/entry/get-create-room-modal-data`);
    }, []);

    return (
        <ErrorBoundary fallback={<FormSkeleton />}>
            <Suspense fallback={<FormSkeleton />}>
                <CreateRoomForm fetchFormData={fetchFormData} onSubmit={onSubmit} />
            </Suspense>
        </ErrorBoundary>
    );
}

export default CreateRoomFormContainer;
